<template>
	<div
		class="button-discard"
		:class="{disabled: disabled}"
	>
		<Icon
			icon-name="refresh"
			size="lg"
		/>
		<span>{{ transUcfirst('commons.discard') }}</span>
	</div>
</template>

<script>
export default {
	name:  'DiscardButton',
	props: {
		disabled: {
			type:    Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.button-discard {
	@include text-md-1;
	color: var(--color-hype-yellow);
	padding: 12px 0;
	white-space: nowrap;
	cursor: pointer;
	width: 208px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		margin-left: 8px;
	}

	&.disabled {
		visibility: hidden;
		opacity: 0;
	}
}
</style>
